module.exports = __webpack_public_path__ + "static/media/transparent-wallet.79e98c75.svg";